// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1uqY3","label":"Section_label__xvQCt","contentWrap":"Section_contentWrap__1BuHZ","footer":"Section_footer__3p7Gg","footerInner":"Section_footerInner__126lK"};